import { PropsWithChildren } from 'react';
import { Box, InputLabel, Stack, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { important } from '../../../../utils/global/helper';
import Required from '../Required';

interface Props {
  name: string;
  label?: string;
  description?: string;
  tooltip?: string;
  isLabelMultiline?: boolean;
  required?: boolean;
  noDisabledBgColor?: boolean;
}

function InputWrapper({
  children,
  name,
  label,
  description,
  tooltip,
  isLabelMultiline,
  required,
  noDisabledBgColor,
}: PropsWithChildren<Props>) {
  return (
    <Stack
      gap={0.5}
      sx={{
        '& div.Mui-disabled': {
          bgcolor: noDisabledBgColor
            ? 'transparent'
            : theme => theme.palette.lightGrey.main,
        },
        '& input.Mui-disabled, & .MuiSelect-select.Mui-disabled': {
          bgcolor: important('transparent'),
        },
      }}>
      {label && (
        <Stack>
          <Box display="flex" gap={0.75} alignItems="center">
            <InputLabel htmlFor={name}>
              <Typography
                variant="h5"
                lineHeight={isLabelMultiline ? 1.5 : undefined}
                whiteSpace={isLabelMultiline ? 'pre-wrap' : undefined}>
                {label}
                {required && <Required />}
              </Typography>
            </InputLabel>
            {tooltip && (
              <Tooltip
                title={tooltip}
                arrow
                placement="top"
                enterTouchDelay={0}>
                <InfoOutlinedIcon sx={{ fontSize: 12, cursor: 'pointer' }} />
              </Tooltip>
            )}
          </Box>
          {description && (
            <Typography variant="body2" whiteSpace="pre-line">
              {description}
            </Typography>
          )}
        </Stack>
      )}
      {children}
    </Stack>
  );
}

export default InputWrapper;
